module.exports = "<div class=\"super-room wrapper\" ng-if=::$ctrl.model.IsSuperRoom><span class=\"super-room super-room-title\" uib-tooltip-html=::$ctrl.amenitiesTooltipOfSuperRoom tooltip-placement=bottom><l10n>Super Room</l10n></span></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hotels/hotel-room/hotel-room-super-room/hotel-room-super-room.html
// module id = 3217
// module chunks = 0